/**
 * ROYAL FIX HOME — centralized route path constants.
 *
 * Every <Link>, redirect, and route definition in the app must reference
 * these constants instead of hardcoded strings, so renaming a route is a
 * one-line change. Grouped by access tier to match the routing
 * architecture defined in Phase 1.
 */

export const PUBLIC_PATHS = {
  HOME: "/",
  SEARCH: "/search",
  PROPERTY_DETAILS: "/property/:id",
  propertyDetails: (id) => `/property/${id}`,
  LOGIN: "/login",
  REGISTER: "/register",
  PREMIUM_INFO: "/premium",
  MAP: "/map",
};

export const USER_PATHS = {
  ADD_PROPERTY: "/add-property",
  FAVORITES: "/favorites",
  PROFILE: "/profile",
  SETTINGS: "/profile/settings",
  MY_LISTINGS: "/profile/my-listings",
  CHAT_LIST: "/chat",
  CHAT_CONVERSATION: "/chat/:conversationId",
  chatConversation: (id) => `/chat/${id}`,
  PREMIUM_CHECKOUT: "/premium/checkout/:listingId",
  premiumCheckout: (listingId) => `/premium/checkout/${listingId}`,
  PAYMENT_RESULT: "/payment/result",
};

export const ADMIN_PATHS = {
  DASHBOARD: "/admin",
  MODERATION: "/admin/moderation",
  USERS: "/admin/users",
  REPORTS: "/admin/reports",
  STATS: "/admin/stats",
};

export const FALLBACK_PATHS = {
  NOT_FOUND: "/404",
  ERROR: "/error",
};
